import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGrid, FiTarget, FiActivity, FiSettings, FiCpu, FiPlayCircle } = FiIcons;

const NAV_ITEMS = [
  { path: '/dashboard', icon: FiGrid, label: 'Console' },
  { path: '/cockpit', icon: FiTarget, label: 'Cockpit' },
  { path: '/analytics', icon: FiActivity, label: 'Stats' },
  { path: '/demo', icon: FiPlayCircle, label: 'Demo' },
  { path: '/settings', icon: FiSettings, label: 'Config' },
];

export default function Layout() {
  const location = useLocation();

  return (
    <div className="flex h-screen w-full bg-[#050914] overflow-hidden selection:bg-[#00F0FF] selection:text-[#050914]">
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex flex-col w-64 border-r border-[#1A233A] bg-[#0A0F1D]/80 backdrop-blur-xl z-20">
        <div className="p-6 flex items-center gap-3 border-b border-[#1A233A]">
          <div className="w-8 h-8 rounded bg-[#00F0FF]/10 border border-[#00F0FF]/50 flex items-center justify-center laser-glow">
            <SafeIcon icon={FiCpu} className="text-[#00F0FF]" />
          </div>
          <span className="font-bold tracking-widest text-[#F4F1EA] uppercase text-sm">FocusForge</span>
        </div>
        
        <nav className="flex-1 py-6 px-4 space-y-2">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `
                flex items-center gap-4 px-4 py-3 rounded-lg transition-all duration-300
                ${isActive 
                  ? 'bg-[#00F0FF]/10 text-[#00F0FF] border border-[#00F0FF]/30 laser-glow' 
                  : 'text-[#8A95A5] hover:text-[#F4F1EA] hover:bg-[#1A233A]/50 border border-transparent'}
              `}
            >
              <SafeIcon icon={item.icon} className="text-lg" />
              <span className="font-medium text-sm tracking-wide">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-[#1A233A]">
          <div className="flex items-center gap-3 px-2 py-2">
            <div className="w-2 h-2 rounded-full bg-[#00F0FF] animate-pulse" />
            <span className="text-xs text-[#8A95A5] font-mono-cyber uppercase tracking-tighter">Link.Active</span>
          </div>
        </div>
      </aside>

      {/* Main Content Area */}
      <main className="flex-1 relative overflow-y-auto overflow-x-hidden hide-scrollbar">
        <div className="absolute inset-0 pointer-events-none opacity-[0.03]" 
             style={{ backgroundImage: 'linear-gradient(#00F0FF 1px, transparent 1px), linear-gradient(90deg, #00F0FF 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
        
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          className="relative z-10 min-h-full p-4 md:p-8 pb-24 md:pb-8"
        >
          <Outlet />
        </motion.div>
      </main>

      {/* Mobile Bottom Nav */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 border-t border-[#1A233A] bg-[#0A0F1D]/90 backdrop-blur-xl z-50 px-4 py-3 flex justify-between items-center">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `
              flex flex-col items-center gap-1 transition-all duration-300
              ${isActive ? 'text-[#00F0FF]' : 'text-[#8A95A5]'}
            `}
          >
            <div className={`p-2 rounded-lg ${location.pathname === item.path ? 'bg-[#00F0FF]/10 laser-glow' : ''}`}>
              <SafeIcon icon={item.icon} className="text-xl" />
            </div>
            <span className="text-[10px] uppercase font-bold tracking-tighter">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}